/** Smoothly interpolate between two coordinate values */
export function lerp(start: number, end: number, t: number): number {
  return start + (end - start) * t;
}

/** Interpolate a [lng, lat] position over time */
export function lerpPosition(
  from: [number, number],
  to: [number, number],
  t: number,
): [number, number] {
  return [lerp(from[0], to[0], t), lerp(from[1], to[1], t)];
}

/** Clamp a value between min and max */
export function clamp(value: number, min: number, max: number): number {
  if (value < min) return min;
  if (value > max) return max;
  return value;
}

/** Convert a Google Maps LatLngLiteral to a [lng, lat] tuple */
export function toLngLat(pos: google.maps.LatLngLiteral): [number, number] {
  return [pos.lng, pos.lat];
}

/** Convert a [lng, lat] tuple to a Google Maps LatLngLiteral */
export function toLatLng(lngLat: [number, number]): google.maps.LatLngLiteral {
  return { lat: lngLat[1], lng: lngLat[0] };
}
